// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Highlights48FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Highlights48Filled: FC<Highlights48FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
        >
            <path d="m42.6 36.7-5.3-5.3 2.1-2.1 5.3 5.3-2.1 2.1Zm-7.2-24-2.1-2.1 5.3-5.3 2.1 2.1-5.3 5.3Zm-22.8 0L7.3 7.4l2.1-2.1 5.3 5.3-2.1 2.1Zm-7.2 24-2.1-2.1 5.3-5.3 2.1 2.1-5.3 5.3Zm6.25 5.3 3.25-14.05L4 18.5l14.4-1.25L24 4l5.6 13.25L44 18.5l-10.9 9.45L36.35 42 24 34.55 11.65 42Z" />
        </svg>
    );
};

export default Highlights48Filled;
